import { render, staticRenderFns } from "./sbvParseList.vue?vue&type=template&id=1dabb111&scoped=true"
import script from "./sbvParseList.vue?vue&type=script&lang=js"
export * from "./sbvParseList.vue?vue&type=script&lang=js"
import style0 from "./sbvParseList.vue?vue&type=style&index=0&id=1dabb111&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dabb111",
  null
  
)

export default component.exports